export default () => {
  return {
    noIndex: true,
  };
};
